import React, {useState, useContext, useRef} from "react";
import {
  apollo_useStyles,
  getModalStyle,
  options_approval_new, 
  valueToOption
} from "../../atom/Apollo_styles";
import {
  accountdetailapollo_path,
  apollo_account_approval_path,
} from "../../atom/Apollo_links";
import {
  ApolloAccountApproveRequest
} from "./AccountModel";
import {ApolloMessage} from "../../atom/Apollo_Mesasge"
import {useHistory} from "react-router-dom";
import moment from "moment"
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import {ApolloContext} from "../../atom/Apollo_Context";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {ApolloDataTable, STORAGE_KEY} from "../../atom/Apollo_DataTable";
import {
  APOLLO_PAGE_ID,
  getApolloPageSizeSetting,
  saveApolloPageSizeSetting,
} from "../../common/Apollo_LocalStorageSettings";

// MODAL
import {MUISortOptions, SelectableRows} from "mui-datatables";
import Card from "@material-ui/core/Card/Card";
import Button from "@material-ui/core/Button";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Grid from "@material-ui/core/Grid";
import CardContent from "@material-ui/core/CardContent";
import Modal from "@material-ui/core/Modal";
import classNames from "classnames";
import Box from "@material-ui/core/Box";

// メッセージ定義
import {
  GetMessage,
  UI_ACCOUNT_UNAPPROVED_LIST,
} from "../../atom/Apollo_MesasgeDefinition";
// TODO操作ログ
import {ApolloEventRecord, LogData, ItemList} from "../../atom/Apollo_EventRecord";

interface UnapprovedAccountListProps {
  children?: React.ReactNode;
  rows: any;
  setTabstate: any;
}

const ApolloUnapprovedAccountList: React.FC<UnapprovedAccountListProps> = ({
  children,
  rows,
  setTabstate,
}) => {

  // 未承認アカウント一覧 チェックボックス処理
  type ids = {
    accountId: number,
    accountgroupId: number,
  };

  // モーダル選択文字定義
  const options_approve = [
    "承認",
    "非承認",
  ];

  const history = useHistory();
  const classes = apollo_useStyles();
  const {state, dispatch} = useContext(ApolloContext);
  const {data, setmsg} = useContext(ApolloMessage);

  const [modalOpen, setModalOpen] = useState(false);
  const [value, setValue] = useState(options_approve[0]);
  const [rowsSelect, setRowsSelect] = useState<ids[]>();
  const [selectIds, setSelectIds] = useState<ids[]>();
  // 操作ログデータ
  const requestData = useRef<any>(null);
  const resultData = useRef<any>(null);
  const resultApi = useRef(-1);
  const logTime = useRef("");

  const [sortOrder, setSortOrder] = useState<MUISortOptions>({
    name: "accountId",
    direction:'asc',
  })
  const [numberOfRows, setNumberOfRows] = useState(
    getApolloPageSizeSetting(APOLLO_PAGE_ID.UNAPPROVED_ACCOUNT_GROUP_LIST)
  )

  // アカウント詳細遷移ハンドラ
  const handleClickOpen = (accountgroupId: number, accountgroupName: string, accountId: number, accountName: string) => {
    dispatch({
      type: "changeAccount",
      payload: {
        ...state,
        current: {
          ...state.current,
          accountGroupId: accountgroupId,
          accountGroupName: accountgroupName,
          accountId: accountId,
          accountName: accountName,
        },
      },
    });
    //画面遷移
    history.push(accountdetailapollo_path + accountgroupId + "/" + accountId + "?type=ap")
  }

  // チェックボッス選択状態初期化
  const handleTableChange = (action: string, tableState: any) => {
    if (action === "propsUpdate" && tableState.selectedRows.data.length > 0 && rowsSelect?.length === 0) {
      // 選択状態を初期化
      tableState.selectedRows = {data:[], lookup:{}}
    }
  }

  // チェックボックスハンドラ
  const handleRowSelect = (selectRow: any, selectRows: any[]) => {
    var workRowSelect:ids[] = [];
    selectRows.map((selectRow) => {
      rows.length > selectRow.dataIndex && workRowSelect.push(selectRow);
      return null;
    })
    setRowsSelect(workRowSelect);
  };
  
  // モーダルオープンハンドラ
  const handleClickOpenDialog = ((body: any) => {
    // 選択しているかチェックする
    const idList = rowsSelect ? rowsSelect.map((data: any, _: number) => {
      let idx = data.dataIndex;
      return {"accountId" : rows[idx].accountId, "accountgroupId" : rows[idx].accountgroupId};
    }) : [];
    if (idList.length < 1) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: GetMessage("0",UI_ACCOUNT_UNAPPROVED_LIST,"V","0"),
        }
      });
      return;
    }
    // 選択したIDを保存
    setSelectIds(idList);
    // モーダルオープン
    setModalOpen(true);
  });

  // 承認・非承認 処理実行
  const updateApproval = ((body: any) => {
    let approvalValue = (body === options_approve[0] ? "2" : "3") ;
    const ids = selectIds?.map((id) => {
      return id.accountId;
    });
    const agReq: ApolloAccountApproveRequest = {
      accountId: ids ? ids : [],
      approval: approvalValue,
    }
    // 操作ログ用にリクエストデータ保存
    requestData.current = agReq;
    // 操作日時をセット
    logTime.current = moment().format("YYYY-MM-DD HH:mm:ss");
    // 操作ログ出力(更新)
    resultApi.current = 0;
    writeLog();
    
    // 承認API呼び出し
    const url = apollo_account_approval_path;
    ApolloAxios.put(url, agReq).then(response => {
      if (response.data.resultCode === 0) {
        // 操作ログ(成功)
        resultApi.current = 1;
        resultData.current = response.data.current;
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "success",
            message: GetMessage("0",UI_ACCOUNT_UNAPPROVED_LIST,"I","0"),
          },
        });
        dispatch({
          type: "setAccount",
          payload: {
            ...state,
            userprofile: response.data.userprofile,
            authorization: response.data.authorization,
            apolloList: response.data.apolloList,
            accesstoken: response.data.accesstoken,
          },
        });
        // 選択情報リセット
        setSelectIds([]);
        setRowsSelect([]);
        // 未承認データ再読み込み(-1で空振りしてから再度当画面を表示)
        setTabstate(-1);
        setTabstate(1);
      } else {
        // 操作ログ(失敗)
        resultApi.current = 9;
        var errMessage = GetMessage("0",UI_ACCOUNT_UNAPPROVED_LIST,"E","0");
        errMessage += response?.data?.message && " (" + response.data.message + ")";
        console.log(response.data.message);
        setmsg({
          type: "all",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: errMessage,
            loading: false
          }
        });
      }
    }).catch(err => {
      // 操作ログ(失敗)
      resultApi.current = 9;
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_UNAPPROVED_LIST,"E","0"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    }).finally(() => {
      // 操作ログ出力(結果)
      writeLog();
    });
  });

  // 未承認アカウント一覧カラム
  const unapprovedColumns = [
    {
      name: "accountId",
      label: "広告主アカウントID",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "accountgroupName",
      label: "アカウントグループ名",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "accountName",
      label: "広告主アカウント名",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "creditLimitAmount",
      label: "与信額",
      options: {
        setCellProps: () => ({
          align: "right"
        }),
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          return value? value.toLocaleString() : 0;
        },
      },
    },
    {
      name: "budgetAmount",
      label: "アカウント月額予算",
      options: {
        setCellProps: () => ({
          align: "right"
        }),
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          return value? value.toLocaleString() : "0";
        },
      },
    },
    {
      name: "requestedAt",
      label: "依頼日",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          return moment(value).format("YYYY-MM-DD");
        },
      },
    },
    {
      name: "requestedBy",
      label: "依頼者",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "",
      label: "詳細",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (idx: number) => {
          return (
            <KeyboardArrowRightIcon
              onClick={() => handleClickOpen(rows[idx].accountgroupId, rows[idx].accountgroupName, rows[idx].accountId, rows[idx].accountName)}
              className={classes.link}
              style={{cursor: "pointer"}}
            />
          );
        },
      },
    },
  ];

  // セレクトボックスマルチ選択指定
  const approveSelectableRows: SelectableRows = 'multiple';
  // 未承認アカウント一覧オプション
  const unapprovedOptions = {
    filter: true, 
    download: false,
    print: false,
    sort: true,  
    sortOrder: localStorage.getItem(STORAGE_KEY.APOLLO_UNAPPROVED_ACCOUNT_LIST) ? undefined : sortOrder,
    selectableRows: approveSelectableRows,
    rowsPerPage: numberOfRows,
    rowsPerPageOptions: [10, 25, 50],
    jumpToPage: true,
    onRowsSelect: handleRowSelect,
    selectableRowsHeader: true,
    selectToolbarPlacement: "none",   // ツールバーの表示を選択状態に切り替えない
    storageKey: STORAGE_KEY.APOLLO_UNAPPROVED_ACCOUNT_LIST,
    onTableChange: handleTableChange,
    onColumnSortChange: (changedColumn: string, direction: string) => {
      setSortOrder({
        name: changedColumn,
        direction: direction,
      } as MUISortOptions)
    },
    onChangeRowsPerPage: (numberOfRows: number) => {
      saveApolloPageSizeSetting(APOLLO_PAGE_ID.UNAPPROVED_ACCOUNT_GROUP_LIST, numberOfRows);
      setNumberOfRows(numberOfRows);
    },
  }

  // 操作ログ出力
  const writeLog = () => {
    // 操作ログ出力を呼ばれるまでは処理しない
    if (resultApi.current < 0) return;
    // 承認するアカウント数分繰り返す
    for (var idx in rows) {
      for (var idx2 in requestData.current.accountId) {
        if (rows[idx].accountId === requestData.current.accountId[idx2]) {
          // 項目リスト
          const itemList: ItemList[] = [
            {
              key: "承認状況",
              beforeValue: valueToOption(1, options_approval_new).label + "",
              afterValue: valueToOption(Number(requestData.current.approval), options_approval_new).label + ""
            },
          ];
          // 操作ログ
          const executionLog: LogData = {
            eventDate: logTime.current, // イベント日時 “YYYY-MM-DD HH:mm:ss“ 形式
            logType: resultApi.current === 0 ? "execute" : "result",// ログ種別 実行：execute, 結果：result
            result: resultApi.current === 0 ? "" : resultApi.current === 1 ? "成功" : "失敗",// 実行結果 成功 / 失敗 ※実行時は空文字
            userID: state.userprofile.userId,// ユーザID
            userName: state.userprofile.userName,// Apolloユーザ名 姓 + 半角スペース + ユーザ名
            accessToken: state.accesstoken, // APIアクセス用トークン
            accountGroupID: rows[idx].accountgroupId, // アカウントグループID
            accountGroupName: rows[idx].accountgroupName, // アカウントグループ名
            accountID: rows[idx].accountId, // 広告主アカウントID
            accountName: rows[idx].accountName, // 広告主アカウント名
            campaignID: "", // キャンペーンID
            campaignName: "", // キャンペーン名
            adGroupID: "", // 広告グループID
            adGroupName: "", // 広告グループ名
            menu: "", // メニュー パフォーマンス広告 / メール広告 / ディスプレイ広告
            displayName: "アカウントグループ一覧(未承認アカウント)画面", // 操作画面名称 〇〇画面
            category: "広告主アカウント", // 操作対象 キャンペーン / セグメント etc...
            actionType: "更新", // アクション 参照 / 作成 / 更新 / 削除 / アップロード
            targetID: resultApi.current === 0 ? "" : rows[idx].accountId + "", // 操作を行うデータのID 実行時は空文字
            targetName: resultApi.current === 0 ? "" : rows[idx].accountName, // 操作を行うデータの名称 実行時は空文字
            itemList: itemList,
          }
          // 操作ログ出力
          ApolloEventRecord(executionLog);
        }
      }  
    }
  };
  
  // 未承認アカウント一覧
  return (
    <div>
      <React.Fragment>
        <Button
          variant="contained"
          color="primary"
          onClick={handleClickOpenDialog}
          className={classes.button}
        >
          一括承認／非承認
        </Button>
      </React.Fragment>

      <Card className={classes.root} square variant="outlined">
        <ApolloDataTable
          title=""
          data={rows ? rows : []}
          columns={unapprovedColumns}
          options={
            {
                ...unapprovedOptions,
                textLabels:{
                    body: {noMatch: "該当データが存在しません"}
                },
            }
        }
/>
      </Card>

      <ConfirmationModal />

    </div>
  );

  // 承認確認モーダル表示
  function ConfirmationModal() {

    const classes = apollo_useStyles();
    const buttonClass = classNames(classes.button, classes.radioSubmit);
    const [modalStyle] = useState(getModalStyle);
    const mStyle = {
      height: 300,
    }
    const bStyle = {
      top: "40%",
    }
    const radioGroupRef = React.useRef<HTMLElement>(null);
  
    const handleModalClose = () => {
      setModalOpen(false);
    };
  
    const handleModalSubmit = () => {
      updateApproval(value);
      setModalOpen(false);
    };
  
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setValue((event.target as HTMLInputElement).value);
    };

    return (
      <React.Fragment>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={modalOpen}
          onClose={handleModalClose}
        >
          <div style={modalStyle} className={classes.paper}>
            <React.Fragment>
              <Card className={classes.root} square variant="outlined">
                <CardContent className={classes.flame} style={mStyle}>
                  <Box m={1}>
                    <Grid item xs={12}>
                    <RadioGroup
                      ref={radioGroupRef}
                      aria-label="approval"
                      name="approval"
                      value={value}
                      onChange={handleChange}
                      className={classes.radioGroup}
                    >
                      {options_approve.map((option) => (
                        <FormControlLabel value={option} key={option} control={<Radio color="primary"/>} label={option} />
                      ))}
                    </RadioGroup>
                    </Grid>
                  </Box>
                  <Button onClick={handleModalSubmit} variant="outlined" color="primary" className={buttonClass} style={bStyle}>
                    決定
                  </Button>
                </CardContent>
                <CardActions className={classes.cardaction}>
                </CardActions>
              </Card>
            </React.Fragment>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

export default ApolloUnapprovedAccountList;
